// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__AktivGroteskGeberit_11b94d', '__AktivGroteskGeberit_Fallback_11b94d', Arial, Sans-serif"},"className":"__className_11b94d"};